import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ModalWindowComponent } from './components/modal-window/modal-window.component';
import { PromotionPanelComponent } from './components/promotion-panel/promotion-panel.component';
import { AppTypePromotionPanelComponent } from './components/promotion-panel/app-type-promotion-panel/apptype-promotion-panel.component';
import { AppMaterialModule } from '../app-material.module';
import { NoticeBannerComponent } from './components/notice-banner/notice-banner.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AddAMemberModalWindowComponent } from './components/family/add-a-member/add-a-member-modal-window.component';
import { FamilyComponent } from './components/family/family.component';
import { FamilySummaryComponent } from './components/family/family-summary/family-summary.component';
import { FamilyWelcomeMessageComponent } from './components/family/family-welcome-message/family-welcome-message.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TextHeroComponent } from './components/text-hero/text-hero.component';
import { ChatHoursModalWindowComponent } from './components/chat-hours-modal-window/chat-hours-modal-window.component';
import { DeviceSelectionDialogComponent } from './components/device-selection-dialog/device-selection-dialog.component';
import { ClaimsNoDevicesModalWindowComponent } from './components/claims-no-devices-modal-window/claims-no-devices-modal-window.component';
import { DashboardDataPlaceholderComponent } from './components/dashboard-data-placeholder/dashboard-data-placeholder.component';
import { GetStartedModalComponent } from './components/get-started-modal/get-started-modal.component';
import { HistoryCardComponent } from './components/history-card/history-card.component';
import { GtmClickDirective } from './directives/gtm-click.directive';
import { NumberMaskPipe } from './pipes/number-mask.pipe';
import { InputNumberDirective } from './directives/input-number.directive';
import { InputErrorComponent } from './components/input-error/input-error.component';
import { MaxLengthDirective } from './directives/max-length.directive';
import { DictionaryPipe } from './pipes/dictionary.pipe';
import { AlphaNumericOnlyDirective } from './directives/alpha-numeric-only.directive';
import { MatGoogleMapsAutocompleteCustomDirective } from './directives/agm.directive';
import { CreditCardDirective } from './directives/creditcard.directive';
import { ExpirationDateDirective } from './directives/expirationdate.directive';
import { MatValidateAddressCustomDirective } from './directives/mat-address-validator.directive';
import { NumberDirective } from './directives/number-directive';
import { OrderByPipe } from './pipes/orderBy.pipe';
import { StylePaginatorDirective } from './directives/style-paginator.directive';
import { CurrencyInputDirective } from './directives/currency-input.directive';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { DeviceContentRequestModalWindowComponent } from './components/device-content-request-modal-window/device-content-request-modal-window.component';
import { FileDragNDropDirective } from './directives/file-drag-n-drop.directive';
import { AssurantLoaderComponent } from './components/assurant-loader';
import { GlobalModalWindowComponent } from './components/global-modal-window/global-modal-window.component';
import { ClaimsSupportFaqComponent } from './components/faq/claim-support-faq/claims-suppport-faq.component';
import { FaqComponent } from './components/faq/faq.component';
import { FaqP360Component } from './components/faq/p360-faq/p360-faq.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { DeviceDisplayNamePipe } from './device/device-display-name.pipe';
import { DeviceBreadcrumbsComponent } from './device/device-breadcrumbs/device-breadcrumbs.component';
import { LoaderProgressComponent } from './components/loader-progress';
import { ADPComponentsModule } from 'digital-core';
import { SettingTrueDirective } from './directives/setting-true.directive';
import { SettingFalseDirective } from './directives/setting-false.directive';
import { ImeiInfoComponent } from 'src/app/modules/device-diagnostics/components/imei-info/imei-info.component';
import { NextStepsComponent } from 'src/app/modules/device-diagnostics/components/next-steps/next-steps.component';
import { ADPImageComponent } from './components/adp-image';
import { DeviceCardComponent } from 'src/app/shared/device/device-card/device-card.component';
import { DeviceInventoryComponent } from './device/device-inventory/device-inventory.component';
import { ADPBannerComponent } from './components/adp-banner/adp--banner.component';
import { SessionTimeoutModalWindowComponent } from './components/session-timeout-modal-window/session-timeout-modal-window.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { NgxMaskPipe } from 'ngx-mask';
import { AriaLabelDirective } from './directives/aria-label.directive';
import { AddressValidationModalWindowComponent } from './components/address-validation-modal-window/address-validation-modal-window.component';
import { SPOEDashboardFaqComponent } from './components/faq/spoe-dashboard-faq/spoe-dashboard-faq.component';
import { SpoeSimpleErrorDialogComponent } from './components/spoe-simple-error-dialog/spoe-simple-error-dialog.component';

const COMPONENTS = [
  AddAMemberModalWindowComponent,
  ConfirmationDialogComponent,
  ChatHoursModalWindowComponent,
  ClaimsNoDevicesModalWindowComponent,
  DashboardDataPlaceholderComponent,
  DeviceBreadcrumbsComponent,
  DeviceSelectionDialogComponent,
  FamilyComponent,
  FamilySummaryComponent,
  FamilyWelcomeMessageComponent,
  GetStartedModalComponent,
  HistoryCardComponent,
  InputErrorComponent,
  ModalWindowComponent,
  ImeiInfoComponent,
  NextStepsComponent,
  NoticeBannerComponent,
  PromotionPanelComponent,
  AppTypePromotionPanelComponent,
  TextHeroComponent,
  DeviceContentRequestModalWindowComponent,
  AssurantLoaderComponent,
  GlobalModalWindowComponent,
  ClaimsSupportFaqComponent,
  SPOEDashboardFaqComponent,
  FaqComponent,
  FaqP360Component,
  AvatarComponent,
  DeviceCardComponent,
  DeviceInventoryComponent,
  LoaderProgressComponent,
  ADPImageComponent,
  ADPBannerComponent,
  SessionTimeoutModalWindowComponent,
  AddressValidationModalWindowComponent,
  SpoeSimpleErrorDialogComponent
];

const DIRECTIVES = [
  GtmClickDirective,
  InputNumberDirective,
  MaxLengthDirective,
  AlphaNumericOnlyDirective,
  CurrencyInputDirective,
  MatGoogleMapsAutocompleteCustomDirective,
  CreditCardDirective,
  ExpirationDateDirective,
  MatValidateAddressCustomDirective,
  NumberDirective,
  AriaLabelDirective,
  StylePaginatorDirective,
  FileDragNDropDirective,
  SettingTrueDirective,
  SettingFalseDirective,
  AutofocusDirective,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    NumberMaskPipe,
    DictionaryPipe,
    OrderByPipe,
    DeviceDisplayNamePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    AppMaterialModule,
    FlexLayoutModule,
    ADPComponentsModule,
  ],
  exports: [
    ...COMPONENTS,
    ...DIRECTIVES,
    AppMaterialModule,
    FlexLayoutModule,
    NumberMaskPipe,
    DictionaryPipe,
    OrderByPipe,
    DeviceDisplayNamePipe,
    ADPComponentsModule,
  ],
  providers: [
    DatePipe,
    NumberMaskPipe,
    OrderByPipe,
    CurrencyPipe,
    NgxMaskPipe],
})
export class SharedModule {}
